import { useState, useEffect } from "react";
import {
  remove_comma,
  check_vat,
  GetWether,
  lifecycleNew,
  GetCookie,
} from "../provider/common";
import { isMemberCheck, isLoginCheck } from "../provider/auth";
import sorter from "sort-nested-json";
// 전역변수
const axios = require("axios").default;
export function usePartsView(data) {
  const [partner, setPartner] = useState("");
  const [item_data, setItem_data] = useState(data);
  const [item_code, setItem_code] = useState(data.code);
  const [item_info, setItem_info] = useState(data.info);
  const [it_name, setIt_name] = useState(data.info.it_name);
  const [prices, setPrices] = useState(data.prices);
  const [it_basic, setIt_basic] = useState(data.info.it_basic);

  const [multiple, setMultiple] = useState(1);
  const [min_qty, setMin_qty] = useState(data.info.moq);
  const [max_qty, setMax_qty] = useState(data.info.qty);
  const [unit_price, setUnit_price] = useState(0);
  const [userType, setUserType] = useState(data.user_type);

  const [total_price, setTotal_price] = useState(0);
  const [total_price_vat, setTotal_price_vat] = useState(0);

  const [manufacturer_str, setManufacturer_str] = useState(
    data.manufacturer_str
  );
  const [manufacturer, setManufacturer] = useState(data.manufacturer);
  const [it_maker, setIt_maker] = useState(data.source);
  const [origin_pn, setOrigin_pn] = useState(data.sku);
  const [lifeCycle] = useState(data.info.it_4_subj);
  const [packaging, setPackaging] = useState(data.info.packaging);

  // HS Code 6자리 (control-plane#196). PandaSearch 상세응답이 대표값 1건을 골라 내려준다.
  // 값이 없는 품목은 null 이라 화면에서 행 자체를 렌더링하지 않는다.
  //
  // 내려오는 값은 숫자만 남긴 6자리(예: "854129") 다. 통관 서류에 쓰는 표기가 네 자리 뒤에
  // 점을 찍는 "8541.29" 라서 화면에서만 그 모양으로 바꿔 준다. 값 자체(PandaSearch 응답)는
  // 손대지 않는다 — 6자리 정규화와 값 선정 규칙은 거기 한 곳에만 있어야 한다.
  //
  // 원본이 짧으면 6자리보다 짧게 올 수도 있다. 그때 네 자리까지는 점을 찍지 않는다.
  // "8541." 처럼 점으로 끝나는 표기를 만들지 않기 위해서다.
  const hs_code = data.hs_code
    ? data.hs_code.length > 4
      ? data.hs_code.slice(0, 4) + "." + data.hs_code.slice(4)
      : data.hs_code
    : null;

  // --- 커스텀 릴 옵션 (control-plane#13) ---
  // 릴은 원래 검색결과에 별도 상품처럼 떠서 고객이 모르고 담고 수수료를 못 보고 넘어갔다.
  // 그래서 릴을 상품이 아니라 이 화면의 "옵션" 으로 내렸다.
  //
  // 서버(PandaSearch getReelOption)가 같은 부품·같은 벤더·같은 재고위치의 형제 행을 찾아준다.
  //   reel : 릴이 아닌 행에서 봤을 때의 릴 형제
  //   base : 릴 행에서 봤을 때의 릴이 아닌 형제 (릴 주소로 바로 들어온 사람이 되돌릴 수 있게)
  const reel_option = data.reel_option ?? null;
  // 릴 주소로 바로 들어왔으면 체크된 상태로 시작한다
  const [isReelSelected, setIsReelSelected] = useState(
    reel_option ? !!reel_option.is_reel : false
  );

  // 옵션을 켜고 끄면 담을 대상 자체가 형제 행으로 바뀐다.
  // null 이면 지금 화면에 뜬 행을 그대로 담으면 된다는 뜻.
  const reel_target = !reel_option
    ? null
    : isReelSelected && !reel_option.is_reel
    ? reel_option.reel
    : !isReelSelected && reel_option.is_reel
    ? reel_option.base
    : null;

  // 되돌릴 형제가 없으면 체크박스를 띄우지 않는다.
  // 형제 없는 릴은 실제로 존재한다(control-plane#13 §6-1). 켰다가 못 끄는 상태를 만들면 안 된다.
  const can_toggle_reel = !reel_option
    ? false
    : reel_option.is_reel
    ? !!reel_option.base
    : !!reel_option.reel;

  const reel_fee = reel_option && isReelSelected ? reel_option.fee : 0;

  // 표시용 포장명. 옵션을 켜면 실제로 담기는 포장이 바뀌므로 표시도 같이 바뀌어야 한다.
  const display_packaging = reel_target ? reel_target.packaging : packaging;

  // 패키징 줄은 디지키 상품에서만 보여준다 (control-plane#13)
  const show_packaging = it_maker === "digikey";
  // 장바구니
  const [it_id, setIt_id] = useState(data.info.it_id);
  const [is_stock, setIs_stock] = useState(data.info.is_stock);
  const [total_qty, setTotal_qty] = useState(data.info.moq);

  const [logistic_weather, setLogistic_weather] = useState({
    it_maker: "onechip",
    period_end: "2022-02-10 (목)",
    period_start: "2022-02-03 (목)",
    weather_str: "선적날씨 - 맑음(정상출고)",
    weather_txt: "sun",
  });
  // 견적바로받기
  const [desiredValue, setDesiredValue] = useState("");
  const [desiredPrice, setDesiredPrice] = useState("");
  const banners = [
    "/images/banner/detail/airport_delivery.png",
    "/images/banner/detail/car_delivery.png",
    "/images/banner/detail/question_delivery.png",
  ];
  const banners_mobile = [
    "/images/banner/detail/airport_delivery_mobile.png",
    "/images/banner/detail/car_delivery_mobile.png",
    "/images/banner/detail/question_delivery_mobile.png",
  ];
  const [bannerIndex, setBannerIndex] = useState(0);
  const [isWish, setIsWish] = useState(false);
  // 할인가격 과 미할인가격 내용 조건 (회원혜택가)
  const [originalPrice, setOriginalPrice] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  // --- 기능들 ---
  const goToDatasheet = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleMinus = () => {
    const min_qty_multiple = Math.floor(min_qty / multiple) * multiple;
    // prev 사용하지 않고, 현재 값을 기반으로 명확 계산
    if (total_qty === "" || isNaN(total_qty)) {
      set_total_price(multiple);
      return;
    }

    let next = Number(total_qty) - multiple;

    // 최소단위 보정
    if (next < min_qty_multiple) {
      next = min_qty_multiple;
    }

    // 실제 숫자만 넣도록 보장
    set_total_price(next);
  };
  const handlePlus = () => {
    const max_qty_multiple = Math.floor(max_qty / multiple) * multiple;
    // prev 사용하지 않고, 현재 값을 기반으로 명확 계산
    if (total_qty === "" || isNaN(total_qty)) {
      set_total_price(multiple);
      return;
    }

    let next = Number(total_qty) + multiple;
    // 최대단위에서 추가되면 보정
    if (next > max_qty_multiple) {
      next = max_qty_multiple;
      set_total_price(next);
      return;
    }

    // 실제 숫자만 넣도록 보장
    set_total_price(next);
  };

  const getWether = async () => {
    const result = await GetWether(it_maker);
    setLogistic_weather(result);
  };

  const getPartner = async () => {
    //백엔드 URL 처리 부분 통합
    const apiUrl = process.env.PANDA_API_URL + "/api/partner/itMaker";
    // Delivery Date 패키지 값 호출
    const data = await axios.get(`${apiUrl}`, {
      params: {
        itMaker: it_maker,
      },
    });
    setPartner(data.data.data);
  };

  const handleMinQtyChange = (value) => {
    // 1) 숫자만 남기기
    const numeric = value.replace(/[^0-9]/g, "");

    // 2) 빈값 입력 중이면 상태도 빈값 유지
    if (numeric === "") {
      set_total_price("");
      return;
    }

    let numericValue = Number(numeric);

    set_total_price(numericValue);
  };

  const handleMinQtyChangeFoucsOut = (value) => {
    const min_qty_multiple = Math.floor(min_qty / multiple) * multiple;
    const max_qty_multiple = Math.floor(max_qty / multiple) * multiple;
    // 1) 숫자만 남기기
    const numeric = value.replace(/[^0-9]/g, "");
    let numericValue = Number(numeric);

    // // 3) 최소 구매단위보다 작으면 보정
    if (numericValue < min_qty_multiple) {
      numericValue = min_qty_multiple;
    }

    // // 5) multiple 단위로 보정 (예: 13 → 20)
    const mod = numericValue % multiple;
    if (mod !== 0) {
      numericValue = numericValue + (multiple - mod);
    }

    // // 4) 최대 재고보다 크면 보정
    if (numericValue > max_qty_multiple) {
      numericValue = max_qty_multiple;
    }

    set_total_price(numericValue);
  };

  const set_total_price = async (qty) => {
    //수량별 단가 계산
    let unit_price = 0;
    let total_price = 0;
    let i = 0;
    if (prices.length > 0) {
      //우선 수량 낮은 순으로 정렬
      const ordered = sorter.sort(prices).asc("Quantity");
      ordered.forEach((element) => {
        if (qty >= element.Quantity) {
          if (userType === "member" || userType === "guest") {
            unit_price = remove_comma(element.price_before);
          } else {
            unit_price = remove_comma(element.Price);
          }
        }
      });
    } else {
      setUnit_price(0);
    }
    total_price = unit_price * qty;
    setTotal_price(total_price);
    setTotal_price_vat(total_price + check_vat(total_price));
    setTotal_qty(qty);
    // 회원혜택가 계산용
    set_seperate_price(qty);
  };

  const set_seperate_price = async (qty) => {
    //수량별 단가 계산
    let original_unit_price = 0;
    let sale_unit_price = 0;

    let original_total_price = 0;
    let sale_total_price = 0;
    if (prices.length > 0) {
      //우선 수량 낮은 순으로 정렬
      const ordered = sorter.sort(prices).asc("Quantity");
      ordered.forEach((element) => {
        if (qty >= element.Quantity) {
          original_unit_price = remove_comma(element.price_before);
          sale_unit_price = remove_comma(element.Price);
        }
      });
    } else {
      setOriginalPrice(0);
      setSalePrice(0);
    }
    original_total_price = qty * original_unit_price;
    sale_total_price = qty * sale_unit_price;

    setOriginalPrice(check_vat(original_total_price) + original_total_price);
    setSalePrice(check_vat(sale_total_price) + sale_total_price);
  };

  // 장바구니 추가
  const _AddCart = async (
    it_id,
    total_qty,
    it_maker,
    origin_pn,
    packaging,
    is_stock
  ) => {
    const token = await GetCookie("token");
    //장바구니 쿠키값이 있는지 체크하기
    //
    // 릴 옵션을 켜면 담는 대상이 형제 행으로 바뀐다.
    // 릴 수수료는 PandaAPI 가 packaging 값을 보고 붙이므로(cart.service.ts) 여기서 금액을 만들지 않는다.
    const data = {
      it_id: Number(it_id),
      quantity: Number(total_qty),
      cart_type: 0,
      it_maker: it_maker,
      origin_pn: reel_target ? reel_target.origin_pn : origin_pn,
      packaging: (reel_target ? reel_target.packaging : packaging) ?? "",
      is_stock: reel_target ? reel_target.is_stock : is_stock,
    };

    // 구매수량과 구매단위 일치 불일치 공식
    // 구매수량과 구매단위이 불일치할 때
    if (data.quantity % multiple != 0) {
      // 구매수량을 구매단위로 나눴을 때 나머지가 있는 상태일 때
      alert("구매단위에 벗어나는 수량입니다.");
      // 구매수량과 구매단위가 일치할 때
    } else if (data.quantity % multiple === 0) {
      // 구매수량을 구매단위로 나눴을 때 나머지가 없는 상태일 때
      const res = await axios.post(
        process.env.PANDA_API_URL + "/api/cart",
        data,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ` + token,
          },
        }
      );
      // 장바구니에 저장
      if (res.data.status === 201) {
        var result = window.confirm(
          "장바구니에 저장되었습니다. 장바구니로 이동할까요?"
        );
        // 장바구니에 이동
        if (result) {
          window.location.href = "/cart/view";
        }
        // 최대 구매수량을 초과했을 때 발생
      } else {
        alert("장바구니 저장중 오류가 발생했습니다. \n사유 : " + res.data.msg);
      }
      return;
    }
  };

  // 찜 추가
  const _addWish = async (no) => {
    const num = Number(no);
    // 로그인 유무 확인
    if ((await isLoginCheck()) == 1) {
      // 찜 여부 확인
      setIsWish(true);
      await axios.post(
        process.env.PANDA_API_URL + "/api/wishlist",
        {
          stocks_no: num,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ` + (await GetCookie("token")),
          },
        }
      );
    } else {
      alert("로그인이 필요한 기능입니다");
      await isMemberCheck();
    }
  };
  // 패키지(data.info.packaging)이 null 혹은 공백값일 때 N/A 넣기
  const isNullPacakageCheck = (value) => {
    const blank_pattern = /^\s+|\s+$/g;
    // 패키지 값이 null일 때
    if (value == null) {
      return "N/A";
    }
    // 패키지 값이 공백일 때
    if (value.replace(blank_pattern, "") == "") {
      return "N/A";
    }
    // 패키지 값이 그 외일 때
    return value;
  };
  // 찜 제거
  const _removeWish = async (no) => {
    if ((await isLoginCheck()) == 1) {
      setIsWish(false);
      const URL = process.env.PANDA_API_URL + `/api/wishlist/${no}`;
      const res = await axios.delete(URL, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ` + (await GetCookie("token")),
        },
      });
    } else {
      alert("로그인이 필요한 기능입니다");
      await isMemberCheck();
    }
  };
  // 견적바로받기 함수
  // 견적 바로 받기
  const requestEstimate = ({ it_name, manufacturer }) => {
    if (
      !desiredValue ||
      isNaN(Number(desiredValue)) ||
      Number(desiredValue) <= 0
    ) {
      alert("유효한 요청수량을 입력해주세요.");
      return;
    }

    if (
      desiredPrice &&
      (isNaN(Number(desiredPrice)) || Number(desiredPrice) <= 0)
    ) {
      alert("유효한 희망가격을 입력해주세요.");
      return;
    }

    const query = new URLSearchParams({
      it_name,
      manufacturer,
      stock: desiredValue,
      requestprice: desiredPrice || "",
    }).toString();

    window.open(`/estimate/quote_request?${query}`, "_blank");
  };

  // --- 초기 로딩 ---
  useEffect(() => {
    if (prices.length > 0) {
      const last = prices.length - 1;
      setMultiple(data.info.unit_no || 1);

      if (userType === "member" || userType === "guest") {
        setUnit_price(remove_comma(prices[last].price_before));
      } else {
        setUnit_price(remove_comma(prices[last].Price));
      }
    } else {
      setMultiple(1);
      setUnit_price(0);
    }

    getWether();
    // 배송정보를 가져오기 위함
    getPartner();
    // 찜 정보를 가져오기 위함
    setIsWish(data.wishlist_flag);
    // 최초가격은 최소수량으로 돌릴 것
    set_seperate_price(min_qty);

    try {
      const saved = Number(localStorage.getItem("bannerIndex")) || 0;
      setBannerIndex(saved);

      const next = (saved + 1) % banners.length;
      localStorage.setItem("bannerIndex", next);
    } catch (e) {
      setBannerIndex(0);
    }
  }, []);

  // 화면에 찍는 단가표.
  // 릴 단가는 컷테이프와 대부분 같지만 디지키가 다른 가격표를 주는 부품이 있다.
  // 옵션을 켰는데 원래 포장의 단가표로 계산하면 화면 금액과 실제 장바구니 금액이 어긋난다.
  // (결제 때 놀라지 않게 하려던 건데 같은 문제가 남는다)
  const display_prices =
    reel_target && reel_target.prices && reel_target.prices.length > 0
      ? reel_target.prices
      : prices;

  // 수량에 해당하는 단가 고르기. set_total_price 와 같은 규칙이되 단가표를 갈아끼울 수 있다.
  const pickUnitPrice = (priceList, qty) => {
    if (!priceList || priceList.length === 0) return 0;
    let picked = 0;
    sorter
      .sort([...priceList])
      .asc("Quantity")
      .forEach((el) => {
        if (qty >= el.Quantity) {
          picked =
            userType === "member" || userType === "guest"
              ? remove_comma(el.price_before)
              : remove_comma(el.Price);
        }
      });
    return picked;
  };

  // 화면에 찍는 주문금액. 고른 포장의 단가표로 계산하고 릴 수수료를 더한다.
  const order_total_price =
    pickUnitPrice(display_prices, total_qty) * total_qty + reel_fee;

  // 포장을 바꾸면 화면 왼쪽 정보도 같이 바뀌어야 한다.
  // 릴과 컷테이프는 재고 행이 서로 달라서 PD번호·SKU·재고·최소수량·구매단위·데이터시트가 다르다.
  // 오른쪽 금액만 바뀌고 왼쪽이 그대로면 서로 다른 상품을 섞어 보여주는 꼴이 된다.
  const display_item_code = reel_target
    ? `PD${reel_target.stock_no}`
    : item_code;
  const display_origin_pn = reel_target ? reel_target.origin_pn : origin_pn;
  const display_datasheet = reel_target
    ? reel_target.datasheet
    : data.info.datasheet;
  // 재고 행의 값이 비어 있을 수 있어 기본값을 받쳐둔다. 화면에서 toLocaleString 을 부른다.
  const display_max_qty = reel_target ? reel_target.qty ?? 0 : max_qty;
  const display_min_qty = reel_target ? reel_target.moq ?? 1 : min_qty;
  const display_multiple = reel_target ? reel_target.unit_no ?? 1 : multiple;
  // 상품명 아래 큰 가격 = 최소수량으로 샀을 때의 금액
  const display_min_price =
    pickUnitPrice(display_prices, display_min_qty) * display_min_qty;

  // 포장을 바꿀 때는 수량도 새 조건에 맞춰준다.
  // 최소수량·구매단위·재고가 포장마다 다를 수 있어, 그대로 두면 담기에서 막힌다.
  const chooseReel = (next) => {
    setIsReelSelected(next);

    const target = !reel_option
      ? null
      : next && !reel_option.is_reel
      ? reel_option.reel
      : !next && reel_option.is_reel
      ? reel_option.base
      : null;

    const nextMin = target ? target.moq ?? 1 : min_qty;
    const nextMax = target ? target.qty ?? 0 : max_qty;
    const nextUnit = target ? target.unit_no ?? 1 : multiple;

    let qty = total_qty;
    if (qty < nextMin) qty = nextMin;
    if (nextMax > 0 && qty > nextMax) qty = nextMax;
    // 구매단위 배수로 내림. 내리다 최소수량 아래로 떨어지면 최소수량으로.
    const floored = Math.floor(qty / nextUnit) * nextUnit;
    qty = floored < nextMin ? nextMin : floored;

    set_total_price(qty);
  };

  return {
    // 상태
    item_data,
    item_info,
    item_code,
    it_name,
    it_basic,
    prices,
    multiple,
    min_qty,
    max_qty,
    unit_price,
    userType,
    manufacturer,
    manufacturer_str,
    it_maker,
    origin_pn,
    lifeCycle,
    packaging,
    hs_code,
    logistic_weather,
    banners,
    banners_mobile,
    bannerIndex,
    total_price,
    total_price_vat,
    // 커스텀 릴 옵션
    reel_option,
    isReelSelected,
    setIsReelSelected,
    can_toggle_reel,
    chooseReel,
    reel_fee,
    display_packaging,
    show_packaging,
    display_prices,
    display_item_code,
    display_origin_pn,
    display_datasheet,
    display_max_qty,
    display_min_qty,
    display_multiple,
    display_min_price,
    order_total_price,
    partner,
    isWish,
    it_id,
    is_stock,
    total_qty,
    originalPrice,
    salePrice,
    desiredValue,
    desiredPrice,
    // 기능
    handleMinus,
    handlePlus,
    goToDatasheet,
    lifecycleNew,
    check_vat,
    handleMinQtyChange,
    handleMinQtyChangeFoucsOut,
    _addWish,
    _removeWish,
    _AddCart,
    isNullPacakageCheck,
    setDesiredValue,
    setDesiredPrice,
    requestEstimate,
  };
}
